import React from 'react';
import { Button, NewInstitutionForm } from '../../components';
import { useModal } from '../../hooks/useModal';
import { useAuth } from '../../contexts/AuthContext';

export const InstitutionsHeader = ({
	fetchInstitutions,
}: {
	fetchInstitutions: Function;
}) => {
	const { visible, toggleModal } = useModal();
	const { user } = useAuth();

	const handleOnNewUserClick = () => {
		toggleModal();
	};

	return (
		<>
			<div className='flex flex-row w-full mb-6 justify-between items-center'>
				<p className='text-lg'>Listado de Instituciones</p>
				<div className='flex flex-row items-center'>
					<Button
						background
						className='w-52 ml-5 !py-2 !px-3'
						textColor='white'
						handleClick={handleOnNewUserClick}
					>
						+ Nueva Institución
					</Button>
				</div>
			</div>
			<NewInstitutionForm
				visible={visible}
				toggle={toggleModal}
				fetchInstitutions={fetchInstitutions}
			/>
		</>
	);
};
